import React, { useState, useEffect } from 'react';

const Industries = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [arrowAnimation, setArrowAnimation] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const serviceSlides = [
    [
      {
        title: "Automotive Industry",
        bgColor: "#2D3748",
        hoverColor: "#4A5568",
        textColor: "#FFFFFF",
        accentColor: "#47D5EB",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/17%202.png?updatedAt=1740727668896",
        description: "Advanced manufacturing solutions for automotive excellence"
      },
      {
        title: "Industrial Manufacturing",
        bgColor: "#FFFFFF",
        hoverColor: "#F7FAFC",
        textColor: "#2D3748",
        accentColor: "#4ECDC4",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/23%20(1).png?updatedAt=1740727668168",
        description: "Streamlined operations for industrial growth"
      },
      {
        title: "Aerospace & Defense",
        bgColor: "#1A202C",
        hoverColor: "#2D3748",
        textColor: "#FFFFFF",
        accentColor: "#E53E3E",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/16.png?updatedAt=1740727667345",
        description: "Mission-critical solutions for aerospace"
      },
      {
        title: "Food & Beverages",
        bgColor: "#FFA630",
        hoverColor: "#FF8C00",
        textColor: "#FFFFFF",
        accentColor: "#FFD700",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/22%20(2).png?updatedAt=1740727666646",
        description: "Quality assurance for food industry"
      }
    ],
    [
      {
        title: "Textile Industries",
        bgColor: "#45B29D",
        hoverColor: "#38A169",
        textColor: "#FFFFFF",
        accentColor: "#68D391",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/21%20(2).png?updatedAt=1740727666183",
        description: "Innovative textile manufacturing solutions"
      },
      {
        title: "High Tech & Electronics",
        bgColor: "#FFFFFF",
        hoverColor: "#F7FAFC",
        textColor: "#2D3748",
        accentColor: "#EFC94C",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/18%20(1).png?updatedAt=1740727664742",
        description: "Cutting-edge technology solutions"
      },
      {
        title: "Construction & Engineering",
        bgColor: "#FFFFFF",
        hoverColor: "#F7FAFC",
        textColor: "#2D3748",
        accentColor: "#E27A3F",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/19%202.png?updatedAt=1740727662773",
        description: "Building the future with smart solutions"
      },
      {
        title: "Logistics & Distribution",
        bgColor: "#9D4EDD",
        hoverColor: "#805AD5",
        textColor: "#FFFFFF",
        accentColor: "#B794F6",
        imageUrl: "https://ik.imagekit.io/kqumni8l2/HomePage/Industries/Industries/20%20(3).png?updatedAt=1740727662559",
        description: "Optimized supply chain management"
      }
    ]
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % serviceSlides.length);
    animateArrow("right");
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + serviceSlides.length) % serviceSlides.length);
    animateArrow("left");
  };

  const animateArrow = (direction) => {
    setArrowAnimation(direction);
    setTimeout(() => setArrowAnimation(false), 500);
  };

  const currentServices = serviceSlides[currentSlide];

  return (
    <div
      className="w-full min-h-screen relative overflow-hidden"
      // style={{background: "linear-gradient(to left,#c11e38, #220b34)"}}
      style={{backgroundColor:'#ffffff'}}
    >
      {/* Animated Background Elements */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute top-20 left-10 w-32 h-32 rounded-full"
          style={{
            background: 'linear-gradient(45deg, #FF6B6B, #4ECDC4)',
            animation: 'float 6s ease-in-out infinite'
          }}
        />
        <div
          className="absolute top-40 right-20 w-24 h-24 rounded-full"
          style={{
            background: 'linear-gradient(45deg, #FFE66D, #FF6B6B)',
            animation: 'float 8s ease-in-out infinite reverse'
          }}
        />
        <div
          className="absolute bottom-20 left-1/4 w-40 h-40 rounded-full"
          style={{
            background: 'linear-gradient(45deg, #4ECDC4, #45B29D)',
            animation: 'float 10s ease-in-out infinite'
          }}
        />
      </div>

      <div
        className={`w-full max-w-7xl mx-auto px-4 sm:px-6 py-20 relative z-10 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
      >

                {/* Label */}
        <div className="flex items-center gap-3 mb-4">
          <span
            className="inline-block w-8 h-[3px] rounded-full"
            style={{ backgroundColor: "#ff0000" }}
          />
          <span
            className="text-xs font-bold tracking-[0.2em] uppercase"
            style={{ color: "#ff0000" }}
          >
            Industries we Serve
          </span>
        </div>
        {/* Header Section */}
        <div className="mb-16 md:mb-20 max-w-7xl">

          <h2 className="text-3xl sm:text-3xl md:text-4xl font-semibold mb-6 leading-tight" style={{ color: '#000000' }}>
            Explore Our Industry-Specific
              ERP Managed Services
            
          </h2>

          <p className="text-lg leading-relaxed" style={{ color: '#000000', wordBreak: 'normal', overflowWrap: 'normal', hyphens: 'none', whiteSpace: 'normal' }}>
            In today's fast-paced business environment, where efficiency and adaptability are key,
            KCS Tech empowers your organization with customized cloud-based ERP solutions that
            streamline operations, enhance decision-making, and drive sustainable growth.
          </p>
        </div>

        {/* Navigation Buttons */}
        {/* <div className="flex justify-start mb-12">
          <div className="flex items-center space-x-4">
            <button 
              onClick={prevSlide}
              className="group w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
              style={{ 
                background: '#F7FAFC',
                border: '2px solid #E2E8F0',
                color: '#691883'
              }}
            >
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className={`transition-transform duration-300 ${
                  arrowAnimation === "left" ? "rotate-45" : ""
                } group-hover:rotate-45`}
              >
                <path d="M12 19V5M5 12L12 5L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            
            <div className="flex space-x-2">
              {serviceSlides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className="transition-all duration-300 hover:scale-125"
                  style={{ 
                    width: currentSlide === index ? '32px' : '12px',
                    height: '12px',
                    borderRadius: '6px',
                    background: currentSlide === index 
                      ? 'linear-gradient(135deg, #E27A3F 0%, #691883 100%)'
                      : '#E2E8F0',
                  }}
                />
              ))}
            </div>
            
            <button 
              onClick={nextSlide}
              className="group w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
              style={{ 
                background: 'linear-gradient(135deg, #E27A3F 0%, #691883 100%)',
                boxShadow: '0 8px 32px rgba(105, 24, 131, 0.3)',
                color: '#FFFFFF'
              }}
            >
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className={`transition-transform duration-300 ${
                  arrowAnimation === "right" ? "rotate-45" : ""
                } group-hover:rotate-45`}
              >
                <path d="M12 5V19M5 12L12 5L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div> */}

        {/* Services Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {currentServices.map((service, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl transition-all duration-500 hover:scale-105 hover:-translate-y-2"
              style={{
                background: '#FFFFFF',
                border: '1px solid #E2E8F0',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                height: '320px',
                animation: `slideUp 0.6s ease-out ${index * 0.1}s both`
              }}
            >
              {/* Image Section */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.imageUrl}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  style={{
                    background: `linear-gradient(135deg, ${service.accentColor}20, ${service.bgColor === '#FFFFFF' ? '#F7FAFC' : service.bgColor}40)`
                  }}
                />
              </div>

              {/* Content Section */}
              <div className="p-6 relative">
                <div
                  className="absolute top-0 left-0 w-16 h-1 transition-all duration-300 group-hover:w-full"
                  style={{ background: service.accentColor }}
                />

                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-xl font-bold transition-colors duration-300" style={{ color: '#2D3748' }}>
                    {service.title}
                  </h3>
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 group-hover:rotate-45 group-hover:scale-110"
                    style={{
                      background: `linear-gradient(135deg, ${service.accentColor}, ${service.hoverColor === '#FFFFFF' ? '#F7FAFC' : service.hoverColor})`
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-white"
                    >
                      <path d="M12 5V19M5 12L12 5L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                </div>

                <p className="text-sm leading-relaxed" style={{ color: '#718096' }}>
                  {service.description}
                </p>
              </div>

              {/* Hover Effect Overlay */}
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                style={{
                  background: `linear-gradient(135deg, ${service.accentColor}05, transparent)`
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Custom Styles */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
        
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        
        .group:hover .group-hover\\:animate-pulse {
          animation: pulse 2s infinite;
        }
      `}</style>
    </div>
  );
};

export default Industries;